export default __webpack_public_path__ + "static/media/underline-cancel-button.c66fa541.svg";